import React from 'react'
import ReactDOM from 'react-dom/client'
import SongContainer from './song'
import { store } from '../../store'
import { Provider } from 'react-redux'

function Wrapper(props) {
  return (
      <Provider store={store}>
          <SongContainer {...props}/>
      </Provider>
  )
}

function songContainer(element) {
  var options = element.dataset;
  var root = ReactDOM.createRoot(element);
  root.render(React.createElement(Wrapper, options));
}

document.addEventListener("DOMContentLoaded", function() {
  var elements = document.querySelectorAll('[data-songcontainer]');
  elements.forEach(songContainer);
});